import styled from 'styled-components';

export const JobIdContainer = styled.div`
  margin-top: 1rem;
`;
